import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MESES = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

export const formatFecha = (iso) => {
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, "0")} · ${MESES[d.getMonth()]} · ${d.getFullYear()}`;
};

const mapPost = (p) => ({
  id: p.id,
  date: formatFecha(p.created_at),
  title: p.title,
  excerpt: p.excerpt,
  body: p.body.split(/\n+/).filter(Boolean),
  premium: !!p.premium,
});

export const usePosts = () => {
  const [posts, setPosts] = useState([]);
  const reload = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/posts`);
      setPosts(data.map(mapPost));
    } catch {
      /* sin publicaciones aún */
    }
  }, []);
  useEffect(() => {
    reload();
    const onChange = () => reload();
    window.addEventListener("posts-changed", onChange);
    return () => window.removeEventListener("posts-changed", onChange);
  }, [reload]);
  return { posts, reload };
};
